(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (() => {
            "use strict";
            if (window.__erksbsNavReady) return;
            window.__erksbsNavReady = true;
            const navRoots = document.querySelectorAll("[data-erksbs-nav]");
            if (!navRoots.length) return;
            const spaces = document.querySelectorAll('.erksbs-space[id^="erksbs-"]');
            const spaceMap = new Map;
            spaces.forEach((space => {
                spaceMap.set(space.id, space);
            }));
            const smoothScroll = target => {
                if (!target) return;
                target.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            };
            const updateActiveCard = activeId => {
                navRoots.forEach((root => {
                    const cards = root.querySelectorAll("[data-erksbs-card]");
                    cards.forEach((card => {
                        const anchor = card.dataset.anchor;
                        if (!anchor) return;
                        if (anchor === "#" + activeId || anchor === activeId) {
                            card.setAttribute("aria-current", "true");
                        } else {
                            card.removeAttribute("aria-current");
                        }
                    }));
                }));
            };
            let rafId = null;
            const onIntersect = entries => {
                if (rafId) cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame((() => {
                    let bestEntry = null;
                    let bestRatio = 0;
                    entries.forEach((entry => {
                        if (entry.isIntersecting && entry.intersectionRatio > bestRatio) {
                            bestRatio = entry.intersectionRatio;
                            bestEntry = entry;
                        }
                    }));
                    if (bestEntry) {
                        updateActiveCard(bestEntry.target.id);
                    } else if (entries.length > 0) {
                        updateActiveCard("");
                    }
                }));
            };
            if (spaces.length > 0) {
                const observer = new IntersectionObserver(onIntersect, {
                    rootMargin: "-30% 0px -60% 0px",
                    threshold: [ 0, .25, .5, .75, 1 ]
                });
                spaces.forEach((space => observer.observe(space)));
            }
            navRoots.forEach((root => {
                root.addEventListener("click", (e => {
                    const card = e.target.closest("[data-erksbs-card]");
                    if (!card) return;
                    const anchor = card.dataset.anchor;
                    if (!anchor) return;
                    e.preventDefault();
                    const targetId = anchor.replace(/^#/, "");
                    const target = document.getElementById(targetId);
                    smoothScroll(target);
                }));
            }));
            const MOBILE_SWIPER_QUERY = window.matchMedia("(max-width: 860px)");
            const createSceneSwiper = root => new Swiper(root, {
                slidesPerView: 1.2,
                spaceBetween: 12,
                pagination: {
                    el: root.querySelector(".swiper-pagination"),
                    clickable: true
                }
            });
            const toggleSceneSwipers = () => {
                if (typeof Swiper === "undefined") return;
                document.querySelectorAll("[data-erksbs-swiper]").forEach((root => {
                    if (MOBILE_SWIPER_QUERY.matches) {
                        if (!root.swiperInstance) {
                            root.swiperInstance = createSceneSwiper(root);
                        }
                    } else if (root.swiperInstance) {
                        root.swiperInstance.destroy(true, true);
                        root.swiperInstance = null;
                    }
                }));
            };
            toggleSceneSwipers();
            MOBILE_SWIPER_QUERY.addEventListener("change", toggleSceneSwipers);
            document.addEventListener("shopify:section:load", (e => {
                if (typeof Swiper === "undefined" || !MOBILE_SWIPER_QUERY.matches) return;
                e.target.querySelectorAll("[data-erksbs-swiper]").forEach((root => {
                    if (!root.swiperInstance) {
                        root.swiperInstance = createSceneSwiper(root);
                    }
                }));
            }));
            document.addEventListener("shopify:section:unload", (e => {
                e.target.querySelectorAll("[data-erksbs-swiper]").forEach((el => {
                    if (el.swiperInstance) {
                        el.swiperInstance.destroy(true, true);
                        el.swiperInstance = null;
                    }
                }));
            }));
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();